export default __webpack_public_path__ + "static/media/bg-upper-left-corner.13e0b80a.svg";